import Vue from 'vue';
import moment from 'moment-timezone';

moment.locale('nb');
moment.tz("Europe/Oslo");
Vue.prototype.$moment = moment;
